import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const api = axios.create({
  baseURL: API_URL,
});

// Přidání JWT tokenu ke každému requestu
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Auth API
export const authAPI = {
  register: (data) => api.post('/auth/register', data),
  login: (data) => api.post('/auth/login', data),
  verify: () => api.get('/auth/verify'),
};

// Game Packs API
export const gamePackAPI = {
  getAll: () => api.get('/gamepacks'),
  getOne: (id) => api.get(`/gamepacks/${id}`),
  create: (data) => api.post('/gamepacks', data),
  update: (id, data) => api.put(`/gamepacks/${id}`, data),
  delete: (id) => api.delete(`/gamepacks/${id}`),
};

export const gameResultAPI = {
  getAll: () => api.get('/gameresults'),
  getOne: (id) => api.get(`/gameresults/${id}`),
  gradePair: (id, data) => api.put(`/gameresults/${id}/grade-pair`, data),
  gradeSolo: (id, data) => api.put(`/gameresults/${id}/grade-solo`, data),
  markComplete: (id) => api.put(`/gameresults/${id}/mark-complete`),
  delete: (id) => api.delete(`/gameresults/${id}`),
};

export default api;
